<template>
  <div 
    class="mt-4">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1 pt-1">
              <v-card
                flat
                style="cursor: pointer;"
                color="#ffffff">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div
                      class="d-flex align-center">
                      <v-icon
                        size="24"
                        :color="set_color">
                        mdi-menu
                      </v-icon>
  
                      <div
                        class="fs-16 black--text ml-3"
                        style="font-weight: 600; padding-top: 1px;">
                        {{ $route.meta.title }}
                      </div>
                    </div>
  
                  </div>
                </v-card-text>
                <v-card 
                  flat
                  style="background-color: transparent;">
                  <v-card-text class="pa-0">
                    <v-card flat 
                      style="border-radius: 0px 0px 6px 6px;">
                      <div :style="{ 'background-color': `${set_color}4a` }" class="d-flex align-center pa-3 justify-center" style="opacity: .7;">

                        <div class="text-center fs-16 mx-5" style="font-weight: 700; cursor: pointer;" :style="selected.view === 0 ? 'background-color: #ffffff; border-radius: 6px; padding: 10px 10px;' : ''" @click="selected.view = 0; update_status = false;">
                          <v-icon size="24" :color="selected.view === 0 ? set_color : '#424242'">mdi-file-document</v-icon>
                          <div class="mt-2 fs-12" :style="{ 'color': selected.view === 0 ? set_color : '#424242' }">Dokumen Legal</div>
                        </div>
      
                        <div class="text-center fs-16 mx-5" style="font-weight: 700; cursor: pointer;" :style="selected.view === 1 ? 'background-color: #ffffff; border-radius: 6px; padding: 10px 10px;' : ''" @click="selected.view = 1; update_status  = false;">
                          <v-icon size="24" :color="selected.view === 1 ? set_color : '#424242'">mdi-book-open-variant</v-icon>
                          <div class="mt-2 fs-12" :style="{ 'color': selected.view === 1 ? set_color : '#424242' }">Kebijakan Privasi</div>
                        </div>

                      </div>
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="background-color: transparent;">
                <v-card-text class="pa-0">
                  <v-card flat 
                    style="border-radius: 6px;">
                    <v-card-text>
                      <div v-if="selected.view === 0">
                        <div class="d-flex align-center justify-space-between">
                          <div class="black--text fs-13" style="font-weight: 600;">
                            Syarat & Ketentuan
                          </div>

                          <div>
                            <v-btn
                              :color="set_color"
                              elevation="0"
                              small
                              v-if="!update_status"
                              @click="reset()"
                              class="white--text text-capitalize">
                              Ubah
                            </v-btn>

                            <v-btn
                              :color="set_color"
                              elevation="0"
                              small
                              v-if="update_status"
                              @click="save()"
                              class="white--text text-capitalize">
                              Simpan
                            </v-btn>
                            <v-btn
                              :color="'red'"
                              elevation="0"
                              small
                              outlined
                              v-if="update_status"
                              @click="update_status = false"
                              class="text-capitalize ml-2">
                              Batal
                            </v-btn>
                          </div>
                        </div>
                        <v-divider class="my-3"></v-divider>

                        <div v-if="process.load">
                          <v-card-text
                            v-if="process.load" 
                            class="pb-0 my-4" 
                            style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                            <div class="text-center">
                              <div class="mb-4 title">
                                Mohon Tunggu . . .
                              </div>
            
                              <v-progress-linear
                                :color="set_color"
                                indeterminate
                                rounded
                                height="10">
                              </v-progress-linear>
                            </div>
                          </v-card-text>
                        </div>

                        <div v-if="!process.load">
                          <div v-if="!update_status">
                            <div class="fs-12">
                              <div class="fs-12" v-html="detail.syarat_ketentuan"></div>
                            </div>
                          </div>

                          <div v-if="update_status">
                            <quill-editor 
                              ref="myTextEditor"
                              :options="{
                                placeholder: 'Contoh. Tuliskan Syarat dan Ketentuan disini . . .',
                              }"
                              v-model="form.syarat_ketentuan">
                            </quill-editor>
                          </div>
                        </div>
                      </div>

                      <div v-if="selected.view === 1">
                        <div class="d-flex align-center justify-space-between">
                          <div class="black--text fs-13" style="font-weight: 600;">
                            Kebijakan Privasi
                          </div>

                          <div>
                            <v-btn
                              :color="set_color"
                              elevation="0"
                              small
                              v-if="!update_status"
                              @click="reset()"
                              class="white--text text-capitalize">
                              Ubah
                            </v-btn>

                            <v-btn
                              :color="set_color"
                              elevation="0"
                              small
                              v-if="update_status"
                              @click="save()"
                              class="white--text text-capitalize">
                              Simpan
                            </v-btn>
                            <v-btn
                              :color="'red'"
                              elevation="0"
                              small
                              outlined
                              v-if="update_status"
                              @click="update_status = false"
                              class="text-capitalize ml-2">
                              Batal
                            </v-btn>
                          </div>
                        </div>
                        <v-divider class="my-3"></v-divider>

                        <div v-if="process.load">
                          <v-card-text
                            v-if="process.load" 
                            class="pb-0 my-4" 
                            style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                            <div class="text-center">
                              <div class="mb-4 title">
                                Mohon Tunggu . . .
                              </div>
            
                              <v-progress-linear
                                :color="set_color"
                                indeterminate
                                rounded
                                height="10">
                              </v-progress-linear>
                            </div>
                          </v-card-text>
                        </div>

                        <div v-if="!process.load">
                          <div v-if="!update_status">
                            <div class="fs-12">
                              <div class="fs-12" v-html="detail.kebijakan_privasi"></div>
                            </div>
                          </div>

                          <div v-if="update_status">
                            <quill-editor 
                              ref="myTextEditor"
                              :options="{
                                placeholder: 'Contoh. Tuliskan Syarat dan Ketentuan disini . . .',
                              }"
                              v-model="form.kebijakan_privasi">
                            </quill-editor>
                          </div>
                        </div>

                      </div>
                    </v-card-text>  
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
import moment from "moment"
import "moment/locale/id"
export default {
  data () {
    return {
      filter: {
        school_id: '',
      },
      selected: {
        view: 0
      },
      dialog: {
        snackbar: false,
        fullscreen: false,
        form: false
      },
      update_status: false,
      form: {
        id: '',
        syarat_ketentuan: '',
        company_name: '',
        logo: '',
        fav_icon: '',
        color: '',
        kebijakan_privasi: ''
      },
      school: [],

      detail: {},

      process: {
        load: false,
        image: false,
        form: false
      },
      message: {
        success: '',
        error: ''
      }
    }
  },
  components: {
  },
  watch: {
    // 'options': {
    //   handler () {
    //     let pagination = { row: this.limit, page: 1 }
        
    //     this.fetch(pagination)
    //   },
    //   deep: true
    // }
  },
  computed: {
    token () {
      return this.$store.state.token
    },
    user () {
      this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
      return this.$store.state.user
    },
    set_color () {
      return this.$store.state.color
    }
  },
  mounted () {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
        this.process.load = true
       let params = {
      }
      let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/config/data' : 'config/data'

      await get(`${url}`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.detail = res.results.data[0]

          this.process.load = false
        }
      })
    },

    reset () {
      this.update_status = true
      this.form.syarat_ketentuan = this.detail.syarat_ketentuan
      this.form.kebijakan_privasi = this.detail.kebijakan_privasi
      this.form.company_name = this.detail.company_name
      this.form.logo = this.detail.logo
      this.form.fav_icon = this.detail.fav_icon
      this.form.color = this.detail.color
      this.process.form = false
      this.form.id = this.detail.id
    },
    async save () {
      this.message.error = ''
      this.process.form = true
  
      let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/config/update' : 'config/update'

      // SAVE TO REST API
      await post(url, {
        data: this.form
      })
      .then(response => {
        let res = response.data
        
        this.process.form = false

        if (res.status === 200) {
          this.dialog.form = false

          this.dialog.snackbar = true
          this.message.success = res.message

          this.dialog.fullscreen = false

          this.fetchDetail()
          this.update_status = false

        } else {
          this.message.error = res.message
        }
      })
    }
  },
  created () {
  }
}
</script>